// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"813a69e1","453":"c2c9bf4c","849":"24216f77"}[chunkId] + ".chunk.js";
};